import React from 'react';
import PropTypes from 'prop-types';
import { staticURL } from 'core/url';

import {
  BrandsListWrapper,
  BrandWrapper,
} from 'apps/home/workspace/sections/brands.styles';

const list = [
  {
    name: 'Solidworks',
    src: 'assets/brands/solidworks.svg',
  },
  {
    name: 'Rhinoceros',
    src: 'assets/brands/rhinoceros.svg',
  },
  {
    name: 'Creo',
    src: 'assets/brands/creo.svg',
  },
  {
    name: 'Autodesk',
    src: 'assets/brands/autodesk.svg',
  },
  {
    name: 'Siemens',
    src: 'assets/brands/siemens.svg',
  },
];

const BrandsContent = props =>
  !props.list
    ? null
    : props.list.map((obj, i) => (
        <BrandWrapper key={obj.name + i} size={props.size}>
          <img src={staticURL(obj.src)} alt={`${obj.name} brand logo`} />
        </BrandWrapper>
      ));

const BrandsList = props => {
  return (
    <BrandsListWrapper size={props.size}>
      <BrandsContent list={props.list} size={props.size} />
    </BrandsListWrapper>
  );
};

BrandsList.defaultProps = {
  size: 'default',
  list,
};

BrandsList.propTypes = {
  size: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.object),
};

export default BrandsList;
